module.exports = __webpack_public_path__ + "static/media/tricka.9d92d5a5.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/content/devdata/resources/exhibitors/tricka.jpg
// module id = 519
// module chunks = 0